export const getDomain = (url: string): string => {
  try {
    let cleanUrl = url.replace(/^https?:\/\//, '');

    cleanUrl = cleanUrl.replace(/^www\./, '');

    cleanUrl = cleanUrl.split('/')[0];

    cleanUrl = cleanUrl.split(':')[0];

    cleanUrl = cleanUrl.replace(/\.$/, '');

    return cleanUrl.toLowerCase();
  } catch (error) {
    return url
      .toLowerCase()
      .replace(/^https?:\/\/(www\.)?/, '')
      .split('/')[0];
  }
};

//Alternative implementation using URL constructor (more robust for valid URLs)
export const getDomainRobust = (url: string): string => {
  try {
    let fullUrl = url;

    if (!url.match(/^https?:\/\//)) {
      fullUrl = `https://${url}`;
    }

    const urlObj = new URL(fullUrl);
    let hostname = urlObj.hostname;

    hostname = hostname.replace(/^www\./, '');

    return hostname.toLowerCase();
  } catch (error) {
    return getDomain(url);
  }
};

// Checks if a string is a valid domain name
export const isValidDomain = (domain: string): boolean => {
  const domainRegex =
    /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?\.([a-zA-Z]{2,}|[a-zA-Z]{2,}\.[a-zA-Z]{2,})$/;
  return domainRegex.test(domain);
};
